import { useMemo } from 'react';
import { User } from '../types';

export const useManageApprovalUsers = (users: readonly User[]) => {
  const validReviewers = useMemo(
    () =>
      users.filter((user) => {
        const { full_name } = user;
        return !!full_name && user.permissions.includes('can_work_on_issue');
      }),
    [users],
  );

  const validQualityApprovers = useMemo(
    () =>
      users.filter((user) => {
        const { full_name } = user;
        return !!full_name && user.usergroups?.includes('quality') && user.permissions.includes('can_work_on_issue');
      }),
    [users],
  );

  const validOtherApprovers = useMemo(
    () =>
      users.filter((user) => {
        const { full_name } = user;
        return !!full_name && user.usergroups?.includes('normal') && user.permissions.includes('can_work_on_issue');
      }),
    [users],
  );

  const validMergedApprovers = useMemo(() => {
    const byId = new Map<number, User>();
    [...validQualityApprovers, ...validOtherApprovers].forEach((u) => byId.set(u.id, u));
    return Array.from(byId.values());
  }, [validQualityApprovers, validOtherApprovers]);

  const validUsersMap = useMemo(() => {
    return {
      reviewer: validReviewers,
      quality: validQualityApprovers,
      other: validOtherApprovers,
      mergedApprovers: validMergedApprovers,
    };
  }, [validOtherApprovers, validQualityApprovers, validReviewers, validMergedApprovers]);

  return (approvalType: 'quality' | 'other' | 'reviewer' | 'mergedApprovers') => validUsersMap[approvalType];
};
